document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll('.featured-grid__media');
  const items = document.querySelectorAll('.featured-grid__item');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, {
    threshold: 0.5
  });

  videos.forEach(video => {
    if (video.tagName === 'VIDEO') {
      observer.observe(video);
    }
  });

  items.forEach(item => {
    const icon = item.querySelector('.featured-grid__icon');
    const video = item.querySelector('video');

    if (!video || !icon) return;

    icon.style.cursor = 'pointer';

    icon.addEventListener('click', (e) => {
      e.stopPropagation();
      const isMuted = video.muted;

      items.forEach(item => {
        item.classList.remove('has-sound');
      });

      videos.forEach(v => {
        if (v.tagName === 'VIDEO') {
          console.log("is muted");
          v.muted = true;
          
        }
      });
      if (isMuted) {
        video.muted = false;
        video.volume = 1;
        item.classList.add('has-sound');
      } else {
        video.muted = true;
        item.classList.remove('has-sound');
      }
    });
  });
});